import { z } from "zod";
import { PostStatus } from "../enum.js";
import { createPostMediaSchema } from "./create-post.js";

export const updatePostSchema = z
	.object({
		content: z.string().min(1, { message: "Post content is required" }).optional(),
		status: z.enum(PostStatus).optional(),
		group_ids: z.array(z.uuid()).optional(),
		media: z.array(createPostMediaSchema).max(10, { message: "A post can have at most 10 media items" }).optional(),
		scheduled_at: z.iso.datetime({ message: "Invalid schedule date" }).nullable().optional(),
		mentioned_user_ids: z.array(z.uuid()).max(50, { message: "A post can mention at most 50 users" }).optional(),
	})
	.strict();

export type UpdatePostPayload = z.infer<typeof updatePostSchema>;
